import { render, staticRenderFns } from "./pnrForm.vue?vue&type=template&id=385ed4ae&scoped=true&"
import script from "./pnrForm.vue?vue&type=script&lang=js&"
export * from "./pnrForm.vue?vue&type=script&lang=js&"
import style0 from "./pnrForm.vue?vue&type=style&index=0&id=385ed4ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ed4ae",
  null
  
)

export default component.exports